import React, { useState, useEffect } from "react";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";

const MESSAGE_DISPLAY_MS = 3000;
const MESSAGE_TYPE_ERROR = "error";
const MESSAGE_TYPE_SUCCESS = "success";
const MESSAGE_TYPE_WARNING = "warning";

const ALERT_SEVERITIES = Object.freeze({
  [MESSAGE_TYPE_ERROR]: "error",
  [MESSAGE_TYPE_SUCCESS]: "success",
  [MESSAGE_TYPE_WARNING]: "warning",
});

const MESSAGE_BACKGROUND_COLORS = Object.freeze({
  [MESSAGE_TYPE_ERROR]: "var(--color-message-error)",
  [MESSAGE_TYPE_SUCCESS]: "var(--color-primary)",
  [MESSAGE_TYPE_WARNING]: "var(--color-warning)",
});

const MESSAGE_TEXT_COLORS = Object.freeze({
  [MESSAGE_TYPE_ERROR]: "var(--color-message-error-text)",
  [MESSAGE_TYPE_SUCCESS]: "var(--color-on-primary)",
  [MESSAGE_TYPE_WARNING]: "var(--color-on-warning)",
});

const DEFAULT_MESSAGE_BACKGROUND_COLOR = "var(--color-surface-muted)";
const DEFAULT_MESSAGE_TEXT_COLOR = "var(--color-on-primary)";

const getMessageBackgroundColor = (type) =>
  MESSAGE_BACKGROUND_COLORS[type] ?? DEFAULT_MESSAGE_BACKGROUND_COLOR;

const getMessageTextColor = (type) =>
  MESSAGE_TEXT_COLORS[type] ?? DEFAULT_MESSAGE_TEXT_COLOR;

const buildAlertStyle = (type) => ({
  backgroundColor: getMessageBackgroundColor(type),
  boxShadow: "var(--shadow-surface)",
  color: getMessageTextColor(type),
  fontFamily: "Montserrat",
  fontWeight: "bold",
  "& .MuiAlert-icon": {
    color: getMessageTextColor(type),
  },
});

const buildStackStyle = () => ({
  fontFamily: "Montserrat",
  width: "max-content",
});

const renderAlert = ({ message, type }) => {
  const severity = ALERT_SEVERITIES[type];
  if (!severity) return "";

  return (
    <Alert variant="filled" severity={severity} sx={buildAlertStyle(type)}>
      {message}
    </Alert>
  );
};

const InfoMessageComponent = ({ typeOfMessage, message }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (typeOfMessage !== "") {
      setIsVisible(true);
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, MESSAGE_DISPLAY_MS);

      return () => clearTimeout(timer);
    }
  }, [typeOfMessage]);

  const alert = renderAlert({ message, type: typeOfMessage });

  return (
    <Stack sx={buildStackStyle()} spacing={2}>
      {isVisible ? alert : ""}
    </Stack>
  );
};

export default InfoMessageComponent;
